/*
  LOULOUIS · Slipp-motor v1.1
  Låser produkter med datoen «Åpner for alle» (custom.slipp_dato) frem i tid.
  Produktkortene viser «Kommer 21.10 kl. 20» til smykket kommer.
  Gjelder produktkort, produktsiden og siden Kommer snart.
  Innstillinger kommer fra window.LLSlippConfig (snippets/ll-slipp-head.liquid).
*/
(function () {
  'use strict';

  if (window.LLSlipp && window.LLSlipp.ready) return;

  var C = window.LLSlippConfig || {};
  var L = window.LLSlipp = window.LLSlipp || {};
  L.ready = true;
  L.config = C;

  var SEC = 1000;
  var MIN = 60 * SEC;
  var HOUR = 60 * MIN;
  var DAY = 24 * HOUR;
  var EARLY = Math.max(0, parseFloat(C.earlyHours) || 0) * HOUR;
  var ACCESS_PARAM = C.accessParam || 'tilgang';
  var ACCESS_CODE = C.accessCode || 'venteliste';
  var ACCESS_KEY = 'll-slipp-tilgang';
  var JOINED_KEY = 'll-slipp-pameldt';
  var PENDING_KEY = 'll-slipp-venter';

  var WD = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  var WD_S = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
  var MO = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];
  var MO_S = ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'];
  var EN_WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  L.ICON_LOCK = '<svg class="ll-slipp-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path class="ll-slipp-shackle" d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/></svg>';
  L.ICON_OPEN = L.ICON_LOCK.replace('class="ll-slipp-lock"', 'class="ll-slipp-lock is-open"');
  L.ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  L.DOT = '<span class="ll-slipp-dot" aria-hidden="true"></span>';
  L.SEC = SEC;
  L.MIN = MIN;
  L.HOUR = HOUR;
  L.DAY = DAY;
  L.EARLY = EARLY;
  L.PENDING_KEY = PENDING_KEY;

  /* ---------- TID ---------- */

  var offset = 0;
  var synced = false;
  var syncWaiters = [];

  L.now = function () {
    return typeof L.clock === 'function' ? L.clock() : Date.now() + offset;
  };

  /* Bruker klokka til Shopify, ikke klokka på telefonen. */
  L.syncClock = function (done) {
    if (done) syncWaiters.push(done);
    if (synced || typeof L.clock === 'function' || !window.fetch) {
      flush();
      return;
    }
    synced = true;
    var t0 = Date.now();
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) {
        var t1 = Date.now();
        var srv = Date.parse(r.headers.get('Date') || '');
        if (!isNaN(srv)) {
          var o = srv + (t1 - t0) / 2 - t1;
          if (Math.abs(o) > 4000) offset = o;
        }
      })
      .catch(function () {})
      .then(flush);
    function flush() {
      var w = syncWaiters;
      syncWaiters = [];
      w.forEach(function (fn) { try { fn(); } catch (e) {} });
    }
  };

  var fmt = null;
  function parts(ms) {
    var d = new Date(ms);
    try {
      fmt = fmt || new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Oslo', weekday: 'short', year: 'numeric', month: 'numeric',
        day: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      });
      var o = {};
      fmt.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
      return { wd: EN_WD.indexOf(o.weekday), d: +o.day, m: +o.month - 1, h: pad(+o.hour % 24), mi: pad(+o.minute) };
    } catch (e) {
      return { wd: d.getDay(), d: d.getDate(), m: d.getMonth(), h: pad(d.getHours()), mi: pad(d.getMinutes()) };
    }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  L.pad = pad;
  L.cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; };
  /* torsdag 22. oktober kl. 20.00 */
  L.fmtLong = function (ms) { var p = parts(ms); return WD[p.wd] + ' ' + p.d + '. ' + MO[p.m] + ' kl. ' + p.h + '.' + p.mi; };
  /* tor. 22. okt. kl. 20.00 */
  L.fmtShort = function (ms) { var p = parts(ms); return WD_S[p.wd] + ' ' + p.d + '. ' + MO_S[p.m] + ' kl. ' + p.h + '.' + p.mi; };
  /* torsdag 22. oktober */
  L.fmtDay = function (ms) { var p = parts(ms); return WD[p.wd] + ' ' + p.d + '. ' + MO[p.m]; };
  /* 22. okt. */
  L.fmtDate = function (ms) { var p = parts(ms); return p.d + '. ' + MO_S[p.m]; };
  /* 21.10 kl. 20 (minuttene vises bare når de ikke er 00) */
  L.fmtCard = function (ms) { var p = parts(ms); return p.d + '.' + (p.m + 1) + ' kl. ' + (+p.h) + (p.mi === '00' ? '' : '.' + p.mi); };

  L.split = function (ms) {
    ms = Math.max(0, ms);
    return { d: Math.floor(ms / DAY), h: Math.floor(ms % DAY / HOUR), m: Math.floor(ms % HOUR / MIN), s: Math.floor(ms % MIN / SEC) };
  };

  /* 6 d 22 t, 4 t 12 min, 12 min 05 s */
  L.fmtLeft = function (ms) {
    var x = L.split(ms);
    if (x.d > 0) return x.d + ' d ' + x.h + ' t';
    if (x.h > 0) return x.h + ' t ' + x.m + ' min';
    return x.m + ' min ' + pad(x.s) + ' s';
  };

  /* Uten sekunder, for kort som oppdateres sjeldnere. */
  L.fmtLeftCoarse = function (ms) {
    var x = L.split(ms);
    if (x.d > 0) return x.d + ' d ' + x.h + ' t';
    if (x.h > 0) return x.h + ' t ' + x.m + ' min';
    return Math.max(1, x.m) + ' min';
  };

  L.earlyText = function () {
    var h = EARLY / HOUR;
    if (h === 24) return 'et døgn';
    if (h === 48) return 'to døgn';
    return h + ' timer';
  };

  /*
    Tilstanden til et produkt med «Åpner for alle» = open (ms):
    locked:   før ventelisten får tilgang
    waitlist: ventelisten handler, du står ikke på den (eller har ikke lenken)
    early:    ventelisten handler, og du har lenken
    open:     åpent for alle
  */
  L.stateFor = function (open, t) {
    if (t == null) t = L.now();
    if (!open || t >= open) return 'open';
    if (EARLY > 0 && t >= open - EARLY) return L.hasAccess() ? 'early' : 'waitlist';
    return 'locked';
  };

  /* ---------- LAGRING ---------- */

  L.lsGet = function (k, fb) {
    try { var v = window.localStorage.getItem(k); return v ? JSON.parse(v) : fb; } catch (e) { return fb; }
  };
  L.lsSet = function (k, v) {
    try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  };
  L.ssGet = function (k) {
    try { var v = window.sessionStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  };
  L.ssSet = function (k, v) {
    try {
      if (v === null) window.sessionStorage.removeItem(k);
      else window.sessionStorage.setItem(k, JSON.stringify(v));
    } catch (e) {}
  };

  /* Lenken i e-posten til ventelisten: ?tilgang=venteliste. Husker den i 30 dager. */
  function captureAccess() {
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get(ACCESS_PARAM) === ACCESS_CODE) {
        L.lsSet(ACCESS_KEY, { t: Date.now() });
        u.searchParams.delete(ACCESS_PARAM);
        window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
      }
    } catch (e) {}
  }
  captureAccess();

  L.hasAccess = function () {
    var a = L.lsGet(ACCESS_KEY, null);
    return !!(a && a.t && Date.now() - a.t < 30 * DAY);
  };

  L.joined = function () {
    var j = L.lsGet(JOINED_KEY, []);
    return Array.isArray(j) ? j : [];
  };

  L.markJoined = function (key) {
    var j = L.joined();
    if (j.indexOf(key) === -1) {
      j.push(key);
      L.lsSet(JOINED_KEY, j.slice(-200));
    }
  };

  L.isEmail = function (v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim());
  };

  /* Fjerner det Shopify legger i adressen etter en påmelding. */
  L.cleanPostedParam = function () {
    try {
      var u = new URL(window.location.href);
      var hit = false;
      ['customer_posted', 'form_type', 'contact[tags]', 'contact[email]'].forEach(function (k) {
        if (u.searchParams.has(k)) { u.searchParams.delete(k); hit = true; }
      });
      if (hit) window.history.replaceState(window.history.state, '', u.pathname + u.search);
    } catch (e) {}
  };

  L.track = function (name, data) {
    var payload = { event: name };
    data = data || {};
    for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  };

  L.setText = function (el, v) { if (el && el._c !== 't' + v) { el._c = 't' + v; el.textContent = v; } };
  L.setHTML = function (el, v) { if (el && el._c !== 'h' + v) { el._c = 'h' + v; el.innerHTML = v; } };

  /* ---------- PRODUKTKORT ---------- */

  function updateCard(el, t) {
    var open = parseInt(el.getAttribute('data-ll-slipp'), 10) * 1000;
    if (!open) return;
    var st = L.stateFor(open, t);
    if (el.getAttribute('data-state') !== st) el.setAttribute('data-state', st);
    el.hidden = st === 'open';
    var icon = el.querySelector('[data-ll-slipp-icon]');
    var text = el.querySelector('[data-ll-slipp-text]');
    if (st === 'locked') {
      L.setHTML(icon, L.ICON_LOCK);
      L.setText(text, 'Kommer ' + L.fmtCard(open));
    } else if (st === 'waitlist') {
      L.setHTML(icon, L.DOT);
      L.setText(text, 'Ventelisten først');
    } else if (st === 'early') {
      L.setHTML(icon, L.DOT);
      L.setText(text, 'Tidlig tilgang');
    }
  }

  L.updateCards = function (root) {
    var t = L.now();
    var list = (root || document).querySelectorAll('.ll-slipp-kort[data-ll-slipp]');
    for (var i = 0; i < list.length; i++) updateCard(list[i], t);
  };

  /* ---------- PRODUKTSIDEN ---------- */

  var product = null;

  function initProduct() {
    var tpl = document.getElementById('ll-slipp-produkt');
    if (!tpl || !tpl.content) return;
    var open = parseInt(tpl.getAttribute('data-open'), 10) * 1000;
    var handle = tpl.getAttribute('data-handle');
    if (!open || !handle) return;

    var scope = (C.selProduct && document.querySelector(C.selProduct)) || null;
    var anchor = scope && C.selAfter ? scope.querySelector(C.selAfter) : null;
    var frag = document.importNode(tpl.content, true);
    var panel = frag.querySelector('[data-ll-slipp-panel]');
    if (!panel) return;
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(frag, anchor.nextSibling);
    else if (scope) scope.insertBefore(frag, scope.firstChild);
    else return;

    product = {
      open: open,
      handle: handle,
      panel: panel,
      lock: document.getElementById('ll-slipp-las'),
      eyebrow: panel.querySelector('[data-p-eyebrow]'),
      title: panel.querySelector('[data-p-title]'),
      count: panel.querySelector('[data-p-count]'),
      text: panel.querySelector('[data-p-text]'),
      join: panel.querySelector('[data-p-join]'),
      done: panel.querySelector('[data-p-done]'),
      form: panel.querySelector('form'),
      email: panel.querySelector('[data-p-email]'),
      submit: panel.querySelector('[data-p-submit]'),
      error: panel.querySelector('[data-p-error]'),
      state: null
    };

    var pending = L.ssGet(PENDING_KEY);
    var fresh = pending && pending.key === handle && Date.now() - (pending.t || 0) < 30 * MIN;
    var posted = false;
    if (fresh && panel.querySelector('[data-form-error]')) {
      posted = true;
      L.cleanPostedParam();
    } else if (fresh && (panel.querySelector('[data-form-ok]') || /[?&]customer_posted=true/.test(window.location.search))) {
      posted = true;
      L.ssSet(PENDING_KEY, null);
      L.markJoined(handle);
      L.cleanPostedParam();
    }
    if (posted) {
      window.setTimeout(function () {
        try { panel.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        if (product && !product.join.hidden && product.email) product.email.focus({ preventScroll: true });
      }, 200);
    }

    /*
      Sjekken skjer på klikket, før skjemaet sendes. Shopify legger en hCaptcha
      på kundeskjemaer, og den tar over selve innsendingen. Enter i feltet gir
      også et klikk på knappen.
    */
    if (product.submit) {
      product.submit.addEventListener('click', function (e) {
        if (!L.isEmail(product.email.value)) {
          e.preventDefault();
          L.setText(product.error, 'Skriv inn en gyldig e-postadresse.');
          product.email.focus();
          return;
        }
        L.ssSet(PENDING_KEY, { key: handle, src: 'produkt', t: Date.now() });
        L.track('ll_kommer_snart_venteliste', { ll_lansering: handle, ll_kilde: 'produktside' });
        if (typeof L.onSubmit === 'function') {
          e.preventDefault();
          L.onSubmit({ key: handle, src: 'produkt' });
          return;
        }
        L.setText(product.error, '');
        product.submit.classList.add('is-loading');
      });
    }
    renderProduct(L.now());
  }

  function renderProduct(t) {
    if (!product) return;
    var P = product;
    var st = L.stateFor(P.open, t);
    if (st === 'open') {
      if (P.lock && P.lock.parentNode) P.lock.parentNode.removeChild(P.lock);
      if (P.panel && P.panel.parentNode) P.panel.parentNode.removeChild(P.panel);
      product = null;
      return;
    }
    var joined = L.joined().indexOf(P.handle) !== -1;
    var left = P.open - t;
    P.panel.setAttribute('data-state', st);

    if (st === 'early') {
      if (P.lock && P.lock.parentNode) P.lock.parentNode.removeChild(P.lock);
      L.setHTML(P.eyebrow, L.DOT + '<span>Tidlig tilgang</span>');
      L.setText(P.title, 'Du kan handle før alle andre');
      L.setText(P.count, 'Åpner for alle om ' + L.fmtLeft(left));
      P.text.hidden = true;
      P.join.hidden = true;
      P.done.hidden = true;
    } else {
      if (P.lock && !P.lock.parentNode) document.head.appendChild(P.lock);
      if (st === 'waitlist') {
        L.setHTML(P.eyebrow, L.DOT + '<span>Ventelisten handler nå</span>');
        L.setText(P.text, joined
          ? 'Du står på listen. Bruk lenken i e-posten fra oss for å handle nå.'
          : 'Alle andre kan handle om ' + L.fmtLeftCoarse(left) + '.');
      } else {
        L.setHTML(P.eyebrow, L.ICON_LOCK + '<span>Kommer snart</span>');
        L.setText(P.text, EARLY > 0
          ? 'På ventelisten får du handle ' + L.earlyText() + ' før alle andre.'
          : 'Meld deg på, så får du beskjed når det åpner.');
      }
      L.setText(P.title, 'Åpner for alle ' + L.fmtLong(P.open));
      L.setText(P.count, 'Om ' + L.fmtLeft(left));
      P.text.hidden = false;
      P.join.hidden = joined;
      P.done.hidden = !joined;
    }
    P.state = st;
  }

  /* ---------- KLOKKE ---------- */

  function tick() {
    var t = L.now();
    L.updateCards(document);
    renderProduct(t);
  }

  function start() {
    initProduct();
    tick();
    L.syncClock(tick);
    window.setInterval(function () {
      if (document.hidden) return;
      if (product) renderProduct(L.now());
    }, SEC);
    window.setInterval(function () {
      if (!document.hidden) L.updateCards(document);
    }, 20 * SEC);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });

    /* Nye kort som lastes inn senere (last mer, anbefalinger). */
    if (window.MutationObserver) {
      var pendingScan = false;
      new MutationObserver(function (records) {
        if (pendingScan) return;
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.matches('.ll-slipp-kort') || n.querySelector('.ll-slipp-kort'))) {
              pendingScan = true;
              window.requestAnimationFrame(function () { pendingScan = false; L.updateCards(document); });
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  try { document.dispatchEvent(new CustomEvent('ll-slipp:ready')); } catch (e) {}
})();
